import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.101 3.85H17.432V2H15.4331V3.85H8.5469V2H6.54801V3.85H4.87894C3.83952 3.85 2.98999 4.72 2.98999 5.8V20.05C2.98999 21.12 3.83952 22 4.87894 22H19.101C20.1405 22 20.99 21.13 20.99 20.05V5.8C20.99 4.73 20.1405 3.85 19.101 3.85ZM18.9911 20H4.99887V10.55H19.0011V20H18.9911ZM18.9911 8.55H4.99887V5.84H19.0011V8.55H18.9911ZM17.322 14.15H6.66795V12.65H17.332V14.15H17.322ZM17.322 17.95H6.66795V16.45H17.332V17.95H17.322Z" fill={ fill || 'currentColor' }/>
    </svg>

);
